/** @format */

import React from "react";
import ReactDOM from "react-dom";
import "./styles/main.scss";

import Home from "./pages/home";

ReactDOM.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>,
  document.getElementById("root")
);
